import React from 'react';

// Importa componentes necesarios
import PageTitle from '../components/pagetitle';
import CTA from '../components/cta';
import Section from '../components/section';
import Project from '../components/project/project_v3';
import Project2 from '../components/project/project_v2';
import dataSolution from '../assets/fake-data/data-solution';

// Importa datos necesarios
import { stepsRubros, stepsElearning, eventParticipation, cursso } from '../assets/fake-data/data-e-learning';

function Elearning(props) {
    return (
        <div className='inner-page'>
            {/* Título de la página */}
            <PageTitle title='Elearning' />

            {/* Sección de participación en eventos */}
            <Section data={eventParticipation} />

            {/* Sección de rubros */}
            <Project data={stepsRubros} title={'Creamos el mundo virtual que necesitas'} title_2={''} />

            {/* Sección de propuesta de valor */}
            <Section data={cursso} />

            {/* Sección de soluciones */}
            <Project2 data={dataSolution} />

            {/* Sección de contenido e-learning */}
            <Project data={stepsElearning} title={'Accede a nuestro contenido'} title_2={'Desarrolla tu propio contenido'} />

            {/* Llamada a la acción */}
            <CTA />
        </div>
    );
}

export default Elearning;